
import { Component, Vue, Emit, Watch, Prop } from "vue-property-decorator";
import rest from "@/rest";
import { l3draggable, l3droppable } from "@/directives/l3dragDrop";
// components
import CompPdf from "../ExerciseComponents/CompPdf.vue";
import ExpandableCard from "../Shared/ExpandableCard.vue";
import TusFileUploadOverlay from '../Shared/TusFileUploadOverlay.vue';
// interfaces
import {
  CourseElementTypeItem,
  courseElementTypeItems,
} from "@/interfaces/Types";
import { namespace } from "vuex-class";
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import { ExerciseVM } from "@/interfaces/ExerciseVM";
import { CourseElementVm } from "@/interfaces/CourseElementVm";
import { CourseElementType } from "@/interfaces/CourseElementType";
import { FileDetailsVm } from "@/interfaces/FileDetailsVm";
import MarkdownEditor from "../Shared/MarkdownEditor.vue";

const globals = namespace("globals");

@Component({
  components: {
    CompPdf,
    ExpandableCard,
    TusFileUploadOverlay,
    MarkdownEditor
  },
  directives: { l3draggable, l3droppable }
})
export default class PdfElement extends Vue {
  @Prop() element!: CourseElementVm;

  @globals.Getter selectedExercise!: ExerciseVM;

  isBusy = false;
  showMarkdownEditor = false;
  fileToUpload: File | null = null;

  mounted() {}

  openMarkdownEditor() {
    this.showMarkdownEditor = true;
  }

  // onNewFileDropped(fileDetails: FileDetailsVm) {
  //   if (fileDetails.fileType != "Pdf") {
  //     this.$store.commit("ux/SB_FAILURE", {
  //       message: "Bei dieser Datei handelt es sich nicht um ein Pdf.",
  //       timeout: 0,
  //     });
  //     return;
  //   }
  //   this.element.contentUrl = fileDetails.filePath;
  // }
  onUploaded(filePath: string | null) {
    if (!filePath) return;
    this.element.contentUrl = filePath;
    this.element.aiSummary = "";
  }

  onCancelled() {
    // this.fileToUpload = null;
  }

  get dropOptions() {
    return {
      accept: (data: any, ev?: DragEvent) => {
        if (!data) return false;
        if (data?.fileType && data.fileType == "Pdf") return true;
        if (Array.isArray(data) && data[0] && data[0].name && data[0].type) return true;
        return false;
      },
      hoverClass: "drop-hover",
      transferTypes: ["Files"],
      targetGroups: ["pdf-file-details"],
      onDrop: (data: any) => {
        if (data?.fileType && data.fileType == "Pdf") {
          let fileDetails: FileDetailsVm = data;
          this.element.contentUrl = fileDetails.filePath;
          this.element.aiSummary = fileDetails.aiSummary || "";
        } else if (Array.isArray(data) && data[0] && data[0].name && data[0].type) {
          const f = data[0];
          // Accept common pdf mime types or fallback to .pdf extension
          if (!(f.type === 'application/pdf' || f.name.toLowerCase().endsWith('.pdf'))) {
            this.$store.commit("ux/SB_FAILURE", {
              message: "Bei dieser Datei handelt es sich nicht um ein PDF.",
              timeout: 0,
            });
            return;
          }
          this.fileToUpload = data[0]; // trigger upload overlay
        }
      }
    };
  }
}
